import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import { Actions, Body, Title } from "./styles";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    title?: React.ReactNode;
    actions?: React.ReactNode;
    maxWidth?: "xs" | "sm" | "md";
    // Тело занимает всю доступную высоту диалога. Нужно тем, у кого внутри свой
    // прокручиваемый список: на весь экран он иначе остаётся своей фиксированной высоты,
    // а под ним висит пустота.
    fillHeight?: boolean;
    children: React.ReactNode;
}

// На узком вьюпорте диалог разворачивается на весь экран — иначе формы не помещаются.
export const Modal = ({
    open,
    onClose,
    title,
    actions,
    maxWidth = "sm",
    fillHeight,
    children,
}: ModalProps) => {
    const theme = useTheme();
    const isWide = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={maxWidth}
            fullScreen={!isWide}
        >
            {title && (
                <DialogTitle disableTypography>
                    <Title>{title}</Title>
                </DialogTitle>
            )}
            <DialogContent>
                <Body $fillHeight={fillHeight}>{children}</Body>
            </DialogContent>
            {actions && (
                <DialogActions>
                    <Actions>{actions}</Actions>
                </DialogActions>
            )}
        </Dialog>
    );
};
